module.exports = __webpack_public_path__ + "img/e4c718d.svg";